import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { containerTypesApi } from './container-types.api';
import type { ContainerTypesListParams } from '../types';

export const containerTypeKeys = {
  all: ['container-types'] as const,
  lists: () => [...containerTypeKeys.all, 'list'] as const,
  list: (filters: ContainerTypesListParams) =>
    [...containerTypeKeys.lists(), filters] as const,
  details: () => [...containerTypeKeys.all, 'detail'] as const,
  detail: (id: number) => [...containerTypeKeys.details(), id] as const
};

export const containerTypeQueries = {
  list: (filters: ContainerTypesListParams = {}) =>
    queryOptions({
      queryKey: containerTypeKeys.list(filters),
      queryFn: () => containerTypesApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: containerTypeKeys.detail(id),
      queryFn: () => containerTypesApi.getById(id),
      enabled: id > 0
    })
};
